<template>
  <div class="notification-dropdown-wrapper">
    <a class="header-widget-icon notification-icon-trigger" href="#">
      <i class="uil-bell"></i>
      <b v-if="notificationCount > 0" class="notif-count-bubble">
        {{ notificationCount }}
      </b>
    </a>

    <div ref="dropdownRef" class="dropdown-notifications"
         uk-dropdown="pos: top-right;mode:click; animation: uk-animation-slide-bottom-small">
      <div class="dropdown-notifications-headline">
        <h4>{{ $t("home.Notifications") }}</h4>
      </div>

      <div class="dropdown-notifications-content" data-simplebar>
        <ul>
          <template v-for="(item, index) in notificationItems">
            <li v-if="'header_notification_item_' + index" :key="'header_notification_item_' + index">
              <template v-if="hasWebUrl(item)">
                <a href="#" @click.prevent="onNotificationClick(
                    item.parsed_data.webUrl.name,
                    item.parsed_data.webUrl.params,
                    item.id
                  )">
                  <span class="notification-icon btn"><i class="icon-feather-bell"></i></span>
                  <span :class="{ 'font-weight-bold': !item.read_at }" class="notification-text">
                    <template v-if="typeof item.parsed_data.message !== 'undefined'">
                      {{ item.parsed_data.message }}
                    </template>
                    <template v-else>Bir bildiriminiz var</template>
                    <span class="time-ago d-block">
                      {{ formatDate(item.updated_at ? item.updated_at : item.created_at) }}
                    </span>
                  </span>
                </a>
              </template>
              <template v-else>
                <a @click="onNotificationClick('dashboard.notification', null, item.id)">
                  <span class="notification-icon btn"><i class="icon-feather-bell"></i></span>
                  <span :class="{
                    'font-weight-bold': item && item.pivot && +item.pivot.is_read === 0,
                  }" class="notification-text">
                    <template v-if="typeof item.parsed_data.message !== 'undefined'">
                      {{ item.parsed_data.message }}
                    </template>
                    <template v-else>Bir bildiriminiz var</template>
                    <span class="time-ago d-block">
                      {{ formatDate(item.updated_at ? item.updated_at : item.created_at) }}
                    </span>
                  </span>
                </a>
              </template>
            </li>
          </template>
        </ul>
      </div>

      <div class="dropdown-notifications-footer">
        <a href="javascript:void(0)" @click="onSeeAllClick">
          {{ $t("home.see_all") }}
          <i class="icon-line-awesome-long-arrow-right"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";

export default {
  name: "NotificationDropdown",
  props: {
    notificationCount: {
      type: Number,
      default: 0,
    },
    notificationItems: {
      type: Array,
      default: () => [],
    },
    formatDate: {
      type: Function,
      required: true,
    },
  },
  methods: {
    hasWebUrl(item) {
      return (
        typeof item.parsed_data.webUrl !== "undefined" &&
        item.parsed_data.webUrl &&
        typeof item.parsed_data.webUrl.name !== "undefined" &&
        item.parsed_data.webUrl.name !== "" &&
        typeof item.parsed_data.webUrl.params !== "undefined"
      );
    },
    hide() {
      if (this.$refs.dropdownRef) {
        UIkit.dropdown(this.$refs.dropdownRef).hide(0);
      }
    },
    onNotificationClick(routeName, params, itemId) {
      const mergedParams = _.merge({}, { id: itemId }, params);
      if (this.$route.name !== routeName) {
        this.$router.push({ name: routeName, params: mergedParams });
      }
      this.hide();
    },
    onSeeAllClick() {
      if (this.$route.name !== "dashboard.notification") {
        this.$router.push({ name: "dashboard.notification" });
      }
      this.hide();
    },
  },
};
</script>

<style lang="scss" src="./notification-dropdown.scss"></style>
